export default class SubMenuToggle {
  constructor(wrapperEl) {
    if (! wrapperEl || ! wrapperEl instanceof HTMLDocument) return;
    this.wrapper = wrapperEl;
    this.menuItemSelector = '.menu-item-has-children';
    this.toggleSelector = '.sub-menu-toggle';
    // this.subMenuSelector = '.sub-menu';
    this.menuItems = this.wrapper.querySelectorAll(this.menuItemSelector);
    if (! this.menuItems) return;

    this.bindEvents();
  }
  bindEvents() {
    this.menuItems.forEach(menuItem => {
      let toggle = menuItem.querySelector(`:scope > ${this.toggleSelector}`);
      toggle.addEventListener('click', () => {
        this.toggleSubMenu(menuItem);
      });
    });
  }
  toggleSubMenu(menuItem) {
    if (menuItem.classList.contains('is-active')) {
      this.closeSubMenu(menuItem);
    }
    else {
      this.openSubMenu(menuItem);
    }
  }
  openSubMenu(menuItem) {
    menuItem.classList.add('is-active');

    let neighbouringMenus = menuItem.parentElement.querySelectorAll(this.menuItemSelector);
    if (! neighbouringMenus) return;

    neighbouringMenus.forEach(neighbouringMenu => {
      if (menuItem === neighbouringMenu) return;
      neighbouringMenu.classList.remove('is-active');
    });
  }
  closeSubMenu(menuItem) {
    menuItem.classList.remove('is-active');

    let childrenMenus = menuItem.querySelectorAll(this.menuItemSelector);
    if (! childrenMenus) return;

    childrenMenus.forEach(childMenu => {
      childMenu.classList.remove('is-active');
    });
  }
}
